exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hourglass{display:block;margin:3em auto;width:2em;height:4em;animation:hourglass 1s linear infinite}.outer{fill:var(--b2b-primary)}.middle{fill:#fff}@keyframes hourglass{0%{transform:rotate(0deg);box-shadow:inset var(--b2b-primary) 0 0 0 0,inset var(--b2b-primary) 0 -4em 0 0}80%{transform:rotate(0deg);box-shadow:inset var(--b2b-primary) 0 -2em 0 0,inset var(--b2b-primary) 0 -2em 0 0}to{transform:rotate(180deg);box-shadow:inset var(--b2b-primary) 0 -2em 0 0,inset var(--b2b-primary) 0 -2em 0 0}}", ""]);

// exports
